/* eslint-env browser, node */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setInitialRegistationFee } from '../../redux/modules/registration';
import getPipeValue from '../../modules/getPipeValue';
import precise from '../../modules/precise';
import TextInput from '../../components/TextInput';

class InitialRegistrationFee extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange() {
    const { applyInitialRegistrationFee, selectedVehicleValue, initialRegistrationFee } = this.props;
    const r19 = Number(getPipeValue(selectedVehicleValue, 'r19'));

    let fee = Number(initialRegistrationFee);
    let allowChecked = applyInitialRegistrationFee;

    if (applyInitialRegistrationFee) {
      // just 'uncheck' the values
      fee = 0;
      allowChecked = false;
    }

    if (!applyInitialRegistrationFee) {
      if (r19 === 2) {
        alert('Initial $225 Registration Fee not charged on this Vehicle type');
        allowChecked = false;
        fee = 0;
      } else {
        fee = 225;
        allowChecked = true;
      }
    }

    this.props.setInitialRegistationFee(precise(fee), allowChecked);
  }

  render() {
    const { applyInitialRegistrationFee, initialRegistrationFee } = this.props;
    return (
      <div className="Row Registration-secondYearFee">
        <TextInput tabIndex="-1" className="Row-total" id="Rsub3" tooltip="Registration Renewal Penalty Fees" value={initialRegistrationFee} readOnly />
        <input className="no-print" id="Initial" checked={applyInitialRegistrationFee || false} onChange={this.onChange} data-tooltip="Check to include the Initial Registration Fee, if charging transfer fee plus initial $225, complete transfer box first." type="checkbox" />
        <label className="no-print" htmlFor="Initial">$225 Initial Registration Fee</label>
        <b className="print-label print-only">Initial Registration Fee</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    initialRegistrationFee: state.registration.initialRegistrationFee,
    applyInitialRegistrationFee: state.registration.applyInitialRegistrationFee,
    transferFee: state.registration.transferFee,
    selectedVehicleValue: state.registration.selectedVehicleValue,
  };
};

export default connect(mapStateToProps, { setInitialRegistationFee })(InitialRegistrationFee);
